var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'fullScreen':_vm.$route.meta.fullScreen},attrs:{"id":"app"}},[(!_vm.$route.meta.fullScreen)?_c('commonHeadVue'):_vm._e(),_c('div',{staticClass:"container f-row"},[(!_vm.$route.meta.fullScreen)?_c('navMenu'):_vm._e(),_c('div',{staticClass:"route_view",class:{'h2':_vm.$route.name=='Login'}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }